import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../constants/common'
import { NotificationInline } from '../Notification'
import { Skeleton } from '../Skeleton'

import { QA_NAME_CALENDAR_SETTINGS_LOAD_ERROR } from './CalendarSettings.constants'
import { useCalendarSettingsData } from './CalendarSettings.hooks'
import { CalendarSettingsForm } from './CalendarSettingsForm'

import * as styles from './CalendarSettings.module.css'

function CalendarSettings() {
  const { t } = useTranslation()

  const { handleSaveSettings, isLoading, serverError, settings } =
    useCalendarSettingsData()

  return isLoading ? (
    <Skeleton className={styles.skeleton} />
  ) : serverError ? (
    <NotificationInline
      qaName={QA_NAME_CALENDAR_SETTINGS_LOAD_ERROR}
      text={t('Error.CommonApiRequestFailKey')}
      type={NOTIFICATION_TYPE.error}
    />
  ) : (
    <CalendarSettingsForm settings={settings} onSave={handleSaveSettings} />
  )
}

export default CalendarSettings
